import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { STORY_IMAGE } from "@/data/site";

const input =
  "w-full rounded-xl border border-sand bg-ivory px-4 py-3.5 text-sm outline-none transition-colors placeholder:text-ink/40 focus:border-ink";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(form.name, form.email, form.password);
      toast.success("Welcome to Noora");
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-ivory md:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-sm">
          <Link to="/" className="font-serif text-2xl tracking-[0.18em]">NOORA</Link>
          <h1 className="mt-10 font-serif text-4xl font-light tracking-tight text-ink">Create Account</h1>
          <p className="mt-2 text-sm text-ink/60">Join the Noora list for exclusive offers.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <input required placeholder="Full name" value={form.name} onChange={upd("name")} className={input} data-testid="register-name" />
            <input required type="email" placeholder="Email address" value={form.email} onChange={upd("email")} className={input} data-testid="register-email" />
            <input required type="password" placeholder="Password (min 6 characters)" value={form.password} onChange={upd("password")} className={input} data-testid="register-password" />
            {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
            <button type="submit" disabled={busy} className="w-full rounded-full bg-ink py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ivory transition-colors hover:bg-gold disabled:opacity-60" data-testid="register-submit">
              {busy ? "Creating…" : "Create Account"}
            </button>
          </form>

          <p className="mt-6 text-sm text-ink/60">
            Already have an account?{" "}
            <Link to="/login" className="link-underline text-ink" data-testid="to-login">Log in</Link>
          </p>
        </div>
      </div>

      <div className="relative hidden overflow-hidden md:block">
        <img src={STORY_IMAGE} alt="Noora" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/20" />
        <div className="absolute bottom-10 left-10 text-ivory">
          <p className="font-serif text-4xl font-light">Made to shine. Made to last.</p>
        </div>
      </div>
    </div>
  );
}
